var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcRgaStandard20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.336 2 17 18h-2.605l-.012-.029-1.198-2.988-.539-1.344-.125-.154a4.358 4.358 0 0 0-6.862.08l-.107.137L3.942 18H3l.026-.064L9.489 2zm-1.3 2.72-2.854 7.304-.037.096c1.602-1.454 4.115-1.466 5.834-.153l-.217-.579z"
})));
export default SvgIcRgaStandard20X20;